import { render } from "./ZaikoJanListPage.vue?vue&type=template&id=b39000f0"
import script from "./ZaikoJanListPage.vue?vue&type=script&lang=js"
export * from "./ZaikoJanListPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__